<template>
    <div>
        <Header/>
            <div class="container container_boletines">
                <SecondHeader/>
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <div class="container_items">
                            <p class="title_second_experiencie">
                                Código
                            </p>
                            <p class="result_second_experience">
                                EXP1
                            </p>
                        </div>
                        <div class="container_items">
                            <p class="title_second_experiencie">
                                Ubicación
                            </p>
                            <p class="result_second_experience">
                                Norte de Santander / Los Patios
                            </p>
                        </div>
                        <div class="container_items">
                            <p class="title_second_experiencie">
                            Nombre
                            </p>
                            <p class="result_second_experience">
                                Agua y comida en un entorno saludable.
                            </p>
                        </div>
                        <div class="container_items">
                            <p class="title_second_experiencie">
                            Gremio
                            </p>
                            <p class="result_second_experience">
                                Agricultura familiar.
                            </p>
                        </div>
                        <div class="container_items">
                            <p class="title_second_experiencie">
                            Nivel y subnivel de Adaptación
                            </p>
                            <p class="result_second_experience">
                                Comunitario / veredal.
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="container_items">
                            <p class="title_second_experiencie">
                            Medida individual o conjunto de medidas.
                            </p>
                            <p class="result_second_experience">
                                Conjunto de medidas
                            </p>
                        </div>
                        <div class="container_items">
                            <p class="title_second_experiencie">
                            Datos de contacto
                            </p>
                            <p class="result_second_experience">
                                Persona, Cargo, 3132100482
                            </p>
                        </div>
                        <div class="container_items">
                            <p class="title_second_experiencie">
                            Proyecto o estrategia en la que se enmarca
                            </p>
                            <div class="result_second_experience">
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing </p>
                                <p>elit. Facere praesentium dolores dolorem doloribus </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <Footer/>
    </div>
</template>



<script>
import Header from "./partials/Header"
import SecondHeader from "./partials/SecondHeader"
import Footer from "./partials/Footer"

export default {
  components:{
      Header,
      SecondHeader,
      Footer,
  },
}
</script>


<style>
    .title_second_experiencie{
        font-size: 30px;
        color: #3366CC;
        font-weight: bolder;
    }
    
    .container_items{
        margin-bottom: 30px;
        margin-top: 5px;
    }
</style>


